// extracted by css-extract-rspack-plugin
export default {"labelWrapper":"JrGC5","label":"CIiEZ","labelActive":"BhEli"};